module.exports = __webpack_public_path__ + "img/icon_code_3.0d182055.png";